import { api } from '@/helpers/apiClient'
import logger, { toErrorMessage } from '@/helpers/logger'
import {
  proposalHcpJobsDtoSchema,
  type ProposalHcpJobsDto,
} from '@lib/dto/hcp-job.dto'
import type {
  CreateHcpJobInput,
  SettleHcpJobInput,
} from '@lib/input/housecall-pro.input'
import type { IProposalHcpJobService } from '@/types/ProposalHcpJobService.types'

/** Service for the Housecall Pro jobs an accepted proposal becomes. */
class ProposalHcpJobService implements IProposalHcpJobService {
  async preview(versionId: string): Promise<ProposalHcpJobsDto> {
    try {
      return await api.get(
        `/proposal-versions/${encodeURIComponent(versionId)}/hcp-jobs`,
        proposalHcpJobsDtoSchema,
      )
    } catch (error) {
      logger.error('Failed to load the Housecall Pro jobs for a proposal', {
        versionId,
        error: toErrorMessage(error),
      })
      throw error
    }
  }

  async create(
    versionId: string,
    input: CreateHcpJobInput,
  ): Promise<ProposalHcpJobsDto> {
    try {
      return await api.post(
        `/proposal-versions/${encodeURIComponent(versionId)}/hcp-jobs`,
        input,
        proposalHcpJobsDtoSchema,
      )
    } catch (error) {
      logger.error('Failed to create a Housecall Pro job', {
        versionId,
        error: toErrorMessage(error),
      })
      throw error
    }
  }

  async settle(
    versionId: string,
    recordId: string,
    input: SettleHcpJobInput,
  ): Promise<ProposalHcpJobsDto> {
    try {
      return await api.put(
        `/proposal-versions/${encodeURIComponent(versionId)}/hcp-jobs/${encodeURIComponent(recordId)}`,
        input,
        proposalHcpJobsDtoSchema,
      )
    } catch (error) {
      logger.error('Failed to settle a Housecall Pro job', {
        versionId,
        recordId,
        error: toErrorMessage(error),
      })
      throw error
    }
  }
}

export const proposalHcpJobService: IProposalHcpJobService =
  new ProposalHcpJobService()
